import storeManager from '../../store/StoreManager';
import connectionStatusConstants from '../../constants/ConnectionStatusConstants';

const apiReader = {
    isOnline() {
        const state = storeManager.getState();
        return state.api.isOnline;
    },

    isServerOK() {
        const state = storeManager.getState();
        return state.api.isServerOK;
    },

    isDisconnected() {
        const state = storeManager.getState();
        return state.api.connectionStatus === connectionStatusConstants.DISCONNECTED;
    },

    getUserResponseQueue() {
        const state = storeManager.getState();

        try {
            return state.api.userResponseQueue || [];
        } catch (ex) {
            return [];
        }
    },

    getUserResponseQueueStatus() {
        const state = storeManager.getState();

        try {
            const { lastResult, lastDateTime } = state.api.userResponseQueueStatus;
            return {
                lastResult,
                lastDateTime,
            };
        } catch (ex) {
            return {
                lastResult: null,
                lastDateTime: null,
            };
        }
    },

    hasPendingResponseSendingRequests() {
        const state = storeManager.getState();
        return state.api.pendingResponses.length > 0;
    },

    hasUnsavedUserResponses() {
        return this.hasPendingResponseSendingRequests() || this.getUserResponseQueue().length > 0;
    },

    hasUnsavedResponsesUpUntilQuestion(currentQuestionId) {
        const state = storeManager.getState();
        const { sections = [] } = state.assessment;
        const unsavedResponses = state.api.pendingResponses;
        const currentSectionId = state.currentlyShown.sectionId;
        const currentSection = sections.find(section => section.id === currentSectionId);
        const currentQuestion = currentSection.questions.find(question => question.contentRevisionId === currentQuestionId);
        if (!currentQuestion) {
            return false;
        }

        return unsavedResponses.some((unsavedResponse) => {
            const unsavedResponseId = parseInt(unsavedResponse.split('-')[0], 10);
            const unsavedResponseQuestion = currentSection.questions.find(question => question.contentRevisionId === unsavedResponseId);
            return unsavedResponseQuestion.questionNumberInQuestionSet < currentQuestion.questionNumberInQuestionSet;
        });
    },

};

export default apiReader;
